import * as Yup from 'yup';
import validation from 'modules/v2/common/validationSchema';

const validationSchema = Yup.object().shape({
  allSegments: validation.campaignAllSegments,
  segments: validation.campaignSegments,
  startDate: validation.campaignStartDate,
});

export default validationSchema;
